import { render, staticRenderFns } from "./DoorImpacts.vue?vue&type=template&id=42f287ba&scoped=true"
import script from "./DoorImpacts.vue?vue&type=script&lang=ts"
export * from "./DoorImpacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f287ba",
  null
  
)

export default component.exports